import { ThemeEvents } from '@theme/events';

class CartIcon extends HTMLElement {
  #rebuySyncTimeout = null;

  constructor() {
    super();
    this.cartCount = null;
    this.addToCartBehavior = null;

    this.clickHandler = this.handleClick.bind(this);
    this.cartUpdatedHandler = this.onCartUpdated.bind(this);
    this.rebuyCartUpdatedHandler = this.onRebuyCartUpdated.bind(this);
  }

  connectedCallback() {
    this.addToCartBehavior = this.dataset.addToCartBehavior || 'open_cart';

    this.cartCount = this.querySelector('[data-ref="cart-count"]');

    this.addEventListener('click', this.clickHandler);
    document.addEventListener(ThemeEvents.cartUpdated, this.cartUpdatedHandler);

    document.addEventListener('rebuy:cart.change', this.rebuyCartUpdatedHandler);
    document.addEventListener('rebuy:cart.add', this.rebuyCartUpdatedHandler);
    document.addEventListener('rebuy.add', this.rebuyCartUpdatedHandler);
    document.addEventListener('rebuy:smartcart.line-item-increase', this.rebuyCartUpdatedHandler);
    document.addEventListener('rebuy:smartcart.line-item-decrease', this.rebuyCartUpdatedHandler);
    document.addEventListener('rebuy:smartcart.line-item-removed', this.rebuyCartUpdatedHandler);
  }

  disconnectedCallback() {
    clearTimeout(this.#rebuySyncTimeout);

    document.removeEventListener('rebuy:cart.change', this.rebuyCartUpdatedHandler);
    document.removeEventListener('rebuy:cart.add', this.rebuyCartUpdatedHandler);
    document.removeEventListener('rebuy.add', this.rebuyCartUpdatedHandler);
    document.removeEventListener('rebuy:smartcart.line-item-increase', this.rebuyCartUpdatedHandler);
    document.removeEventListener('rebuy:smartcart.line-item-decrease', this.rebuyCartUpdatedHandler);
    document.removeEventListener('rebuy:smartcart.line-item-removed', this.rebuyCartUpdatedHandler);

    document.removeEventListener(ThemeEvents.cartUpdated, this.cartUpdatedHandler);
    this.removeEventListener('click', this.clickHandler);
  }

  getCurrentItemCount() {
    const count = parseInt(this.cartCount?.textContent, 10);
    return Number.isNaN(count) ? 0 : count;
  }

  onCartUpdated(event) {
    const itemCount = event.detail.data.itemCount;
    if (Number.isFinite(itemCount)) {
      this.#setCartCount(itemCount);
    }

    if (this.addToCartBehavior == 'open_cart') this.openCart();

    // ponytail: sync via API — le tiroir Rebuy (type app) ne reflète pas le DOM thème
    setTimeout(() => {
      this.ensureCartCountIsCorrect();
    }, 100);
  }

  onRebuyCartUpdated() {
    this.#scheduleRebuyCartSync();
  }

  #scheduleRebuyCartSync() {
    clearTimeout(this.#rebuySyncTimeout);
    this.#rebuySyncTimeout = setTimeout(() => {
      this.ensureCartCountIsCorrect();
    }, 50);
  }

  // Utile quand des apps (cadeaux, etc.) modifient le panier après l'ajout.
  ensureCartCountIsCorrect() {
    fetch(Theme.routes.cart_url)
      .then((response) => response.json())
      .then((cart) => {
        this.#setCartCount(cart.item_count);
      })
      .catch((error) => {
        console.error('Failed to fetch cart via API:', error);
      });
  }

  #setCartCount(count) {
    this.cartCount.textContent = count;

    const bubble = this.querySelector('.header__icon-count-bubble');
    if (!bubble) return;

    bubble.classList.toggle('header__icon-count-bubble--long', count >= 100);
  }

  handleClick() {
    this.openCart();
  }

  openCart() {
    const cartDrawer = document.querySelector('[data-ref="cart-drawer"]');
    if (cartDrawer) {
      if (cartDrawer.type === 'app') {
        Rebuy.SmartCart.show();
      } else {
        cartDrawer.open();
      }
    }
  }
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}